import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Hero from "../../../components/ui/Hero";

export default function NosotrosHero() {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        pt: { xs: 10, lg: 15 },
        pb: { xs: 8, lg: 12 },
        bgcolor: "#f8fafc",
        overflow: "hidden",
      }}
    >
      {/* Círculos decorativos */}
      <Box
        sx={{
          position: "absolute",
          top: "-20%",
          right: "-10%",
          width: 800,
          height: 800,
          borderRadius: "50%",
          bgcolor: "rgba(0, 86, 179, 0.05)",
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
        <Hero t={t} prefix={"nosotros"} />

        {/* Bloque Esencia */}
        <Box
          sx={{
            mt: 10,
            p: { xs: 4, md: 8 },
            bgcolor: "#F8F9FA",
            borderRadius: 3,
            position: "relative",
            border: "1px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              width: 6,
              background: "linear-gradient(to bottom, #68a8de, #0056b3)",
            }}
          />

          <Typography
            component="span"
            sx={{
              fontSize: "10px",
              fontWeight: 700,
              color: "#0056b3",
              letterSpacing: "0.25em",
              textTransform: "uppercase",
              display: "block",
              mb: 2,
            }}
          >
            {t("nosotros.hero.tag")}
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.2rem", md: "1.5rem" },
              fontWeight: 500,
              color: "#0A1128",
              lineHeight: 1.6,
            }}
          >
            {t("nosotros.hero.essence")}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
